import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const mins = (t) => (t ? Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5)) : 0);

export const LunchFields = ({ start, end, onChange, testid = "lunch", className = "" }) => {
  const d = start && end ? mins(end) - mins(start) : null;
  const bad = d != null && (d < 60 || d > 180);
  return (
    <div className={`space-y-2 ${className}`}>
      <Label>Pausa pranzo (da 1 a 3 ore, facoltativa)</Label>
      <div className="flex items-center gap-2">
        <Input type="time" value={start || ""} onChange={(e) => onChange({ lunch_start: e.target.value || null, lunch_end: end })} className="w-32" data-testid={`${testid}-start`} />
        <span className="text-slate-400">–</span>
        <Input type="time" value={end || ""} onChange={(e) => onChange({ lunch_start: start, lunch_end: e.target.value || null })} className="w-32" data-testid={`${testid}-end`} />
      </div>
      <p className={`text-xs ${bad ? "text-red-600" : "text-slate-500"}`}>{bad ? "La pausa deve durare da 1 a 3 ore" : "Il tempo timbrato in questa fascia viene tolto dalle ore di lavoro."}</p>
    </div>
  );
};
